import { render, staticRenderFns } from "./framed-box.vue?vue&type=template&id=0c46efc0&scoped=true&"
import script from "./framed-box.vue?vue&type=script&lang=ts&"
export * from "./framed-box.vue?vue&type=script&lang=ts&"
import style0 from "./framed-box.vue?vue&type=style&index=0&id=0c46efc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c46efc0",
  null
  
)

export default component.exports